<template>
	<div>
		<div v-for="(match, index) in matches" :key="index">
			<matches :show-header="false" :list="match"></matches>
		</div>
	</div>
</template>

<script>
	import Matches from "./Matches";
	
	export default {
		components: {
			Matches
		},
		
		props: ['matches']
	}
</script>

<style scoped>

</style>